import React, { useCallback } from 'react';

import classNames from 'classnames';
import * as fromProjects from 'store/Projects';

import { Default } from "./Default/Default";
import { FullBleedImage } from "./FullBleedImage/FullBleedImage";

interface IProps {
  animationReady: boolean;
  bodyContent: object;
  quotationBackgroundShade: fromProjects.IBackgroundShadeTypes;
}

export const Quotation: React.FC<IProps> = ({ animationReady, quotationBackgroundShade, ...props }) => {
  const bodyContent: fromProjects.IContentQuotationSection = props.bodyContent as fromProjects.IContentQuotationSection;

  const getComponent = useCallback(() => {
    const itemVariation: fromProjects.IContentQuotationVariations = bodyContent.variation;

    const listComponentCommonProps = {
      animationReady,
      quotationBackgroundShade,
    };

    if (itemVariation === 'default') {
      const content: fromProjects.IContentQuotationDefault = bodyContent.content as fromProjects.IContentQuotationDefault;
      return <Default {...listComponentCommonProps} content={content} />;
    } else if (itemVariation === 'fullBleedImage') {
      const content: fromProjects.IContentQuotationFullBleedImage = bodyContent.content as fromProjects.IContentQuotationFullBleedImage;
      return <FullBleedImage {...listComponentCommonProps} content={content} />;
    }
  }, [animationReady]);

  return (
    <div
      className={classNames(
        'projectQuotationWrapper',
        bodyContent.variation,
      )}
    >
      {getComponent()}
    </div>
  );
};


